/* eslint-disable max-len */
import { number, string } from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const ServiceTicketSvg = styled.svg`
  width: ${prop('size', 36)}px;
  height: ${prop('size', 36)}px;
  :hover {
    .b {
      fill: ${prop('hoverColor', colorsOptions.greys['grey-100'])};
    }
  }

  .a {
    fill: none;
  }
  .b {
    fill: ${prop('color', colorsOptions.greys['grey-100'])};
  }
`

function ServiceTicketIcon ({ color, hoverColor, size, ...props }) {
  return (
    <ServiceTicketSvg
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <rect className="a" width="32" height="32" />
        </clipPath>
      </defs>
      <g id="Gruppe_3">
        <path
          className="b"
          d="M30.739,13.575H29.063a13.23,13.23,0,0,0-.54-2.007l1.453-.839a1.262,1.262,0,0,0,.461-1.722L29.275,6.992a1.263,1.263,0,0,0-1.723-.461l-1.455.84A13.452,13.452,0,0,0,24.629,5.9l.841-1.455a1.263,1.263,0,0,0-.462-1.722L22.992,1.562a1.261,1.261,0,0,0-1.722.461l-.839,1.453a13.194,13.194,0,0,0-2.007-.539V1.26A1.262,1.262,0,0,0,17.163,0H14.836a1.263,1.263,0,0,0-1.261,1.26V2.937a13.186,13.186,0,0,0-2.007.539L10.73,2.023a1.262,1.262,0,0,0-1.723-.461L6.992,2.726a1.262,1.262,0,0,0-.461,1.722L7.371,5.9A13.335,13.335,0,0,0,5.9,7.371L4.447,6.531a1.259,1.259,0,0,0-1.722.461L1.561,9.008a1.263,1.263,0,0,0,.461,1.722l1.453.839a13.308,13.308,0,0,0-.54,2.007H1.261A1.262,1.262,0,0,0,0,14.837v2.327a1.262,1.262,0,0,0,1.261,1.261H2.936a13.258,13.258,0,0,0,.54,2.006l-1.453.839a1.26,1.26,0,0,0-.462,1.722l1.164,2.016a1.262,1.262,0,0,0,1.722.461l1.455-.84A13.271,13.271,0,0,0,7.371,26.1l-.841,1.456a1.263,1.263,0,0,0,.461,1.722l2.016,1.164a1.263,1.263,0,0,0,1.722-.462l.839-1.453a13.245,13.245,0,0,0,2.007.54v1.675A1.262,1.262,0,0,0,14.836,32h2.327a1.262,1.262,0,0,0,1.261-1.261V29.064a13.253,13.253,0,0,0,2.007-.54l.839,1.452a1.259,1.259,0,0,0,1.722.463l2.015-1.164a1.263,1.263,0,0,0,.462-1.723L24.629,26.1A13.387,13.387,0,0,0,26.1,24.629l1.455.84a1.263,1.263,0,0,0,1.723-.461l1.163-2.016a1.261,1.261,0,0,0-.461-1.722l-1.453-.839a13.18,13.18,0,0,0,.54-2.006h1.676A1.262,1.262,0,0,0,32,17.163V14.837a1.262,1.262,0,0,0-1.261-1.261m.291,3.588a.29.29,0,0,1-.291.291H28.654a.486.486,0,0,0-.48.413,12.234,12.234,0,0,1-.7,2.6.485.485,0,0,0,.209.6l1.808,1.045a.29.29,0,0,1,.106.4l-1.163,2.015a.291.291,0,0,1-.4.107l-1.81-1.045a.484.484,0,0,0-.621.117A12.382,12.382,0,0,1,23.7,25.607a.486.486,0,0,0-.117.621l1.045,1.809a.292.292,0,0,1-.107.4L22.507,29.6a.29.29,0,0,1-.4-.107l-1.044-1.807a.485.485,0,0,0-.6-.209,12.32,12.32,0,0,1-2.6.7.482.482,0,0,0-.411.478v2.086a.292.292,0,0,1-.291.291H14.836a.292.292,0,0,1-.291-.291V28.653a.482.482,0,0,0-.412-.478,12.342,12.342,0,0,1-2.6-.7.492.492,0,0,0-.176-.033.486.486,0,0,0-.42.242L9.89,29.491a.292.292,0,0,1-.4.107L7.477,28.435a.292.292,0,0,1-.106-.4l1.045-1.809a.486.486,0,0,0-.117-.621A12.412,12.412,0,0,1,6.393,23.7a.484.484,0,0,0-.621-.117l-1.81,1.045a.29.29,0,0,1-.221.029.287.287,0,0,1-.176-.136L2.4,22.507a.29.29,0,0,1,.106-.4l1.808-1.045a.485.485,0,0,0,.209-.6,12.236,12.236,0,0,1-.7-2.6.485.485,0,0,0-.479-.413H1.261a.291.291,0,0,1-.291-.291V14.837a.292.292,0,0,1,.291-.291H3.346a.484.484,0,0,0,.479-.412,12.236,12.236,0,0,1,.7-2.6.485.485,0,0,0-.209-.6L2.508,9.89a.29.29,0,0,1-.106-.4L3.565,7.477a.288.288,0,0,1,.177-.135.284.284,0,0,1,.221.029l1.81,1.045A.486.486,0,0,0,6.393,8.3,12.357,12.357,0,0,1,8.3,6.393a.485.485,0,0,0,.117-.621L7.371,3.963a.292.292,0,0,1,.106-.4L9.492,2.4a.294.294,0,0,1,.221-.029.29.29,0,0,1,.177.137l1.043,1.807a.483.483,0,0,0,.6.209,12.3,12.3,0,0,1,2.6-.7.485.485,0,0,0,.412-.479V1.26a.291.291,0,0,1,.291-.29h2.327a.291.291,0,0,1,.291.29V3.346a.485.485,0,0,0,.411.479,12.279,12.279,0,0,1,2.6.7.484.484,0,0,0,.6-.209L22.11,2.508a.292.292,0,0,1,.177-.136.284.284,0,0,1,.221.029l2.015,1.163a.292.292,0,0,1,.107.4L23.584,5.773a.486.486,0,0,0,.117.621A12.3,12.3,0,0,1,25.607,8.3a.485.485,0,0,0,.621.116l1.81-1.045a.289.289,0,0,1,.4.107L29.6,9.493a.291.291,0,0,1-.106.4l-1.808,1.043a.485.485,0,0,0-.209.6,12.2,12.2,0,0,1,.7,2.6.485.485,0,0,0,.48.412h2.085a.291.291,0,0,1,.291.291Z"
        />
        <path
          className="b"
          d="M25.229,13.944a7.941,7.941,0,0,0-6.289-1.876,7.994,7.994,0,0,0-5.516,12.477.972.972,0,0,1,.151.649L13.3,28.048a.484.484,0,0,0,.63.509L16.9,27.6a.97.97,0,0,1,.6-.01,7.912,7.912,0,0,0,3.315.363,8,8,0,0,0,4.415-14.013M20.715,26.993a6.927,6.927,0,0,1-2.911-.319,1.927,1.927,0,0,0-1.2.007l-2.273.729.207-2.12a1.937,1.937,0,0,0-.32-1.295A7.025,7.025,0,0,1,19.064,13.03a7.033,7.033,0,0,1,7.966,6.845,7.076,7.076,0,0,1-6.315,7.118"
          transform="translate(-4 -4)"
        />
        <path
          className="b"
          d="M25.7,19.156H17.94a.485.485,0,0,0,0,.97H25.7a.485.485,0,0,0,0-.97"
          transform="translate(-5.818 -6.385)"
        />
        <path
          className="b"
          d="M27.879,23.614H24.486a.485.485,0,0,0,0,.969h3.393a.485.485,0,0,0,0-.969"
          transform="translate(-8 -7.871)"
        />
        <path
          className="b"
          d="M17.94,24.583h1.939a.485.485,0,1,0,0-.969H17.94a.485.485,0,1,0,0,.969"
          transform="translate(-5.818 -7.871)"
        />
        <path
          className="b"
          d="M23.273,28.072H17.94a.485.485,0,1,0,0,.97h5.333a.485.485,0,0,0,0-.97"
          transform="translate(-5.818 -9.357)"
        />
      </g>
    </ServiceTicketSvg>
  )
}

ServiceTicketIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number
}

export default ServiceTicketIcon
